const ITEMS = [
    "Hospital Beds",
    "OT Tables",
    "OT Lights",
    "Clean Room & Modular Operation Theatres",
    "CSSD Design",
    "OT Design R&D",
    "CSSD Development",
    "100+ Global Manufacturer Partners",
    "Est. 1988",
];

function Track({ hidden }) {
    return (
        <div
            aria-hidden={hidden || undefined}
            className="flex shrink-0 items-center gap-10 pr-10"
        >
            {ITEMS.map((item) => (
                <div key={item} className="flex items-center gap-10">
                    <span className="whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.3em] text-slate-400">
                        {item}
                    </span>
                    <span className="h-1.5 w-1.5 rotate-45 bg-accent/70" />
                </div>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div
            data-testid="marquee-ribbon"
            className="marquee-wrap relative overflow-hidden border-y border-line bg-panel/40 py-5"
        >
            <div className="marquee-track flex w-max">
                <Track />
                <Track hidden />
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
        </div>
    );
}
